import React from 'react';
import HexToRGBA from './HexToRGBA';
import BoxShadow from './BoxShadow';


import '../styles/main-styles.css';

class App extends React.Component{

	render(){

		return(
      <div>
    		<HexToRGBA />
        <BoxShadow />
    </div>
		)
	}


}



export default App;